import axios from 'axios';
import * as SegmentTracking from '@hotjar/webapp/domains/common/tracking/segment';
import { restDefaultHandlers } from '@hotjar/webapp/utils/rest-default-handlers';
import { Store } from '../../../store/player/types';

/**
 * Get and set user data (we don't have UserData available in this shared recording).
 */
export const fetchUserData = (store: Store): Promise<void> => {
  const { sharingToken, setUser } = store.getState();

  return axios
    .get('/api/v2/users/me', { params: { token: sharingToken } })
    .then(function (res) {
      const user = res.data;
      // Add / Edit / Delete Comments should only be available if the user is browsing their own site
      // (not a shared recording) and the site org is on a PLUS or BUSINESS plan.
      if (user) {
        setUser(user);
        SegmentTracking.setAnonymizedUserId(user.current_ip);
        SegmentTracking.setCountryCode(user.country);
      }
    })
    .catch(restDefaultHandlers.onError);
};
